import { Injectable } from '@angular/core';
import { BrandData } from '../../app/interfaces/brand-data.interface'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class BrandDataService {

  constructor() { }

  getBrandPayload(id: number = 0, email: string = ''): BrandData {
    const host = window.location.hostname;


    let brand: BrandData = {
      id: id,
      email: email,
      isPyrocast: true,
      ignite: false,
      isTune2: false,
      siteName: 'Pyrocast',
      domainUrl: 'https://app.pyrocast.com',
      imageUrl: 'logo-sm.png',
      color: '#2cbcf4'
    };
    if (host === environment.skyDomain) {
      brand.isPyrocast = false;
      brand.ignite = false;
      brand.isTune2 = false;
      brand.siteName = 'Skystream';
      brand.domainUrl = 'https://app.skystreamevents.com';
      brand.imageUrl = 'skystream_logo.png';
      brand.color = '#0f57c6';
    }
    // 3. Tune2 Domains
    else if (host === environment.tune2Domain || host === environment.tune2Domain2) {
      brand.isPyrocast = false;
      brand.ignite = false;
      brand.isTune2 = true;
      brand.siteName = 'Tune2';
      brand.domainUrl = 'https://admin.tune2.app';
      brand.imageUrl = 'tune2-logo.webp';
      brand.color = '#de072a';
    }
    // 4. Ignite Domain
    else if (host === environment.igniteDomain) {
      brand.isPyrocast = false;
      brand.ignite = true;
      brand.isTune2 = false;
      brand.siteName = 'IGNITE Live!';
      brand.domainUrl = 'https://live.ignitefiringsystems.com';
      brand.imageUrl = 'IGNITE_Live_Logo.png';
      brand.color = '#ce38f3';
    }

    return brand;
  }
}

